// Toggles an italic mark on the currently selected elements.
import ToolMark from '../../tools/ToolMark';

class ToolItalic extends ToolMark {
  static toolName = 'Italic';
  static iconClass = 'fa-regular fa-italic';
  static mark = 'italic' as const;
  static shortcut = 'Cmd+i';
}

export default ToolItalic;
